import { callApi, postApi } from '@/api';

function unsupported(operation) {
  throw new Error(`HttpApiCityRepository does not implement ${operation} yet`);
}

export class HttpApiCityRepository {
  async updateCity() {
    unsupported('updateCity');
  }

  async updateCityLicenseExpirationPolicy(cityId, payload) {
    return postApi(`/v1/cities/${cityId}/license-expiration-policy`, payload);
  }

  async updateCityLicenseWorkflowStatuses(cityId, payload) {
    return postApi(`/v1/cities/${cityId}/license-workflow-statuses`, payload);
  }

  async updateCityLicenseApprovalEmailSettings(cityId, payload) {
    return postApi(`/v1/cities/${cityId}/license-approval-email-settings`, payload);
  }

  async updateCityLicenseStatusEmails(cityId, payload) {
    return postApi(`/v1/cities/${cityId}/license-status-emails`, payload);
  }

  async updateCityPrintableLicense(cityId, payload) {
    return postApi(`/v1/cities/${cityId}/printable-license`, payload);
  }

  async previewCityPrintableLicense(cityId, payload) {
    return postApi(`/v1/cities/${cityId}/printable-license/preview`, payload);
  }

  async previewCityLicenseStatusEmailDraft(cityId, payload) {
    return postApi(`/v1/cities/${cityId}/license-status-emails/preview`, payload);
  }

  async sendErrorReport() {
    unsupported('sendErrorReport');
  }

  async queueCityCheck() {
    unsupported('queueCityCheck');
  }

  async ensureDefaultValues(cityId, namespace) {
    return callApi('ensureDefaultFieldsForCity', { cityId }, namespace);
  }
}
